var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2238",
    "data-name": "Group 2238",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.454,
    height: 27.65,
    viewBox: "0 0 20.454 27.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M290.037,265.492a.983.983,0,0,0,.983-.983v-6.1a.983.983,0,0,0-1.967,0v6.1A.983.983,0,0,0,290.037,265.492Z",
    transform: "translate(-282.17 -244.841)",
    fill: "#4b4b4b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M372.487,265.492a.983.983,0,0,0,.983-.983v-6.1a.983.983,0,1,0-1.967,0v6.1A.983.983,0,0,0,372.487,265.492Z",
    transform: "translate(-360.097 -244.841)",
    fill: "#4b4b4b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M188.625,148.757V131.29H168.73v17.466a4.517,4.517,0,0,0,4.517,4.517h10.861a4.516,4.516,0,0,0,4.517-4.517Zm-1.966,0a2.553,2.553,0,0,1-2.55,2.55H173.247a2.553,2.553,0,0,1-2.55-2.55v-15.5h15.962v15.5Z",
    transform: "translate(-168.447 -125.623)",
    fill: "#4b4b4b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M164.564,31.539H183.05a.983.983,0,0,0,0-1.967h-5.511A.979.979,0,0,0,176.757,28h-5.9a.983.983,0,0,0-.983.983.973.973,0,0,0,.2.59h-5.511a.983.983,0,0,0,0,1.967Z",
    transform: "translate(-163.58 -27.999)",
    fill: "#4b4b4b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.9a21da42ef2059a6efe30451e0797a83.svg";
export { ForwardRef as ReactComponent };